import { render, staticRenderFns } from "./otherPopup.vue?vue&type=template&id=ee50063a&scoped=true&"
import script from "./otherPopup.vue?vue&type=script&lang=js&"
export * from "./otherPopup.vue?vue&type=script&lang=js&"
import style0 from "./otherPopup.vue?vue&type=style&index=0&id=ee50063a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee50063a",
  null
  
)

export default component.exports